import {BaseModel} from '../base/BaseModel';

/**
 * @class FarmFeaturesModel
 * @extends BaseModel
 * @deprecated  Due to endpoint breaking change. New endpoint provides a more detailed information about
 *              crop-specific features and related packages. FarmFeatures2Model to be used instead.
 */
export class FarmFeaturesModel extends BaseModel {

    initialize () {

        this.microservice = 'users';
        this.resource = 'farm-features';
    }

    defaults () {

        return  {
            farmUuid : undefined,
            timing : 'INACTIVE',
            timingUuid : undefined,
            timingValidTill : undefined,
            mapping: 'INACTIVE',
            mappingUuid : undefined,
            mappingValidTill : undefined,
            freeOfCharge: false,
        };
    }

    parse (response) {

        if (response) {

            response.uuid = BaseModel.getLocalMoment().unix();

            ['timingValidTill', 'mappingValidTill'].forEach((property) => {
                if (_.isString(response[property])) {
                    response[property] = BaseModel.parseDate(response[property]);
                }
            });
        }

        return response;
    }

    isTimingActive() {
        return (this.attributes.timing === 'ACTIVE');
    }

    isMappingActive() {
        return (this.attributes.mapping === 'ACTIVE');
    }

    isFeatureActive(featureName) {
        return (this.attributes[featureName] === 'ACTIVE');
    }

    static get EXPIRATION() {
        return {
            REGULAR_EXPIRING : __('BASICLAYOUT.EXPIRATION.REGULAR'),
            FOC_EXPIRING : __('BASICLAYOUT.EXPIRATION.FOC'),
            EXPIRED : __('BASICLAYOUT.EXPIRATION.EXPIRED'),
            NO_EXPIRATION : null
        };
    }

    getExpriationInfo () {
        // Timing  Mapping     Result
        // 0       0 =         0 : - All licences expired
        // 0       1 =         1 : => Check for if FOC/Regular license expires in <= 10 days
        // 1       0 =         2 : => Check for if FOC/Regular license expires in <= 10 days
        // 1       1 =         3 : => Check for if FOC/Regular license expires in <= 10 days

        let tmp = 0b0;

        if(this.isTimingActive()){
            tmp = tmp | 0b010;
        }
        if(this.isMappingActive()){
            tmp = tmp | 0b001;
        }

        const attrs = this.attributes;
        // get an expiration text based on foc state
        const getExpirationText = (date) => {
            let diff = date.clone().unix() - BaseModel.getLocalMoment().unix();

            diff = Math.ceil(diff / (24 * 60 * 60));

            if(attrs.freeOfCharge) {
                return _.replace(FarmFeaturesModel.EXPIRATION.FOC_EXPIRING, '<x>', diff);
            } else {
                return _.replace(FarmFeaturesModel.EXPIRATION.REGULAR_EXPIRING, '<x>', diff);
            }
        };
        // is latest of dates less than 10 days from now on?
        const checkDate = (dates) => {

            let date = _.maxBy(dates, (d) => d.unix());
            let isLessThan10 = BaseModel.getLocalMoment()
                                .add(10, 'days')
                                .isAfter(date);

            if(isLessThan10){
                return getExpirationText(date);
            } else{
                return FarmFeaturesModel.EXPIRATION.NO_EXPIRATION;
            }
        };

        switch (tmp) {
            case 0:
                return FarmFeaturesModel.EXPIRATION.EXPIRED;
            case 1:
                return checkDate([attrs.mappingValidTill]);
            case 2:
                return checkDate([attrs.timingValidTill]);
            case 3:
                return checkDate([attrs.timingValidTill, attrs.mappingValidTill]);
            default:
                break;
        }

        return FarmFeaturesModel.EXPIRATION.NO_EXPIRATION;
    }

    static get FEATURES () {

        return {
            TIMING: 'timing',
            MAPPING: 'mapping'
        };
    }

    /**
     * Return false if a feature is not supported, otherwise true.
     * 
     * @param {Array<String>} featureList 
     */
    contains (featureList) {
        return _.every(featureList, (feature) => this.isFeatureActive(feature));
    }
}



// WEBPACK FOOTER //
// ./shared/model/users/FarmFeaturesModel.js